import envs from "config/envs";
import React from "react";

const RedirectToTrainingFile = () => {
  window.location.href = `${envs.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/treinamento-fornecedores-2025-1.pdf`;
  return <h1>Você está sendo redirecionado!</h1>;
};

export default RedirectToTrainingFile;
